import React, { useState } from 'react'
import { Link, useHistory } from "react-router-dom";
import { ArrowLongLeftIcon } from '@heroicons/react/24/solid';
import { PhotoIcon } from '@heroicons/react/24/outline';
import axios from "axios";
import { useAlert } from "react-alert";
import FormData from 'form-data';

const AddValues = () => {


    const [badgeImage, setBadgeImage] = useState(null);
    const [badgeName, setBadgeName] = useState("");
    const [imagePreview, setImagePreview] = useState(null);
    const [errors, setErrors] = useState({});
    const alert = useAlert();
    const history = useHistory();

    const handleFileChange = (event) => {
        const file = event.target.files && event.target.files[0];
        if (file) {
            setBadgeImage(file);
            const reader = new FileReader();
            reader.onloadend = function () {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        const err = {};
        const pattern = /^[a-zA-Z\s]+$/;

        if (!badgeName) {
            err.badgeName = 'Badge name is required';
        }

        if (badgeName && !pattern.test(badgeName)) {
            err.badgeName = 'Only alphabets and space is allowed';
        }

        if (!badgeImage) {
            err.badgeImage = 'Badge image is required';
        }

        const formData = new FormData();
        formData.append('image', badgeImage);

        setErrors(err);

        if (Object.keys(err).length === 0) {

            axios.post(process.env.REACT_APP_API_URL + "api/badges/uploadimage",
                formData,
            )
                .then(function (response) {
                    if (response.data.issuccessful) {
                        axios.post(process.env.REACT_APP_API_URL + "api/badges/addnewbadge", {
                            badgeImage: badgeImage.name,
                            badgeName,
                        })
                            .then(function (response) {
                                if (response.data.issuccessful) {
                                    alert.success(response.data.message)
                                    setTimeout(() => {
                                        history.push('/admin/core-values-awards')
                                    }, 1500)
                                } else {
                                    alert.error(response.data.message)
                                }
                            })
                    } else {
                        alert.error(response.data.message)
                    }
                })
                .catch(function (error) {
                    alert.error(error);
                });
        }

    }



    return (
        <div style={{ position: "relative" }} className="rewardRequest">

            <Link to="/admin/core-values-awards" className='admin-header'>
                <ArrowLongLeftIcon className="" style={{ width: '30px' }} />
                <p style={{ marginBottom: '0' }} >Add Core Value</p>
            </Link>

            <form onSubmit={handleSubmit} className='edit-user-form'>
                <div className='user-form-div'>
                    <div>
                        <div style={{ position: 'relative' }}>
                            <label>Image<span style={{ color: 'red' }}>*</span></label>
                            {imagePreview ? (
                                <div style={{ position: 'absolute', cursor: 'pointer', height: '150px', width: '100%', border: '1px solid #3b3b3b', borderRadius: '10px', display: 'grid', placeItems: "center" }}>
                                    <img src={imagePreview} style={{
                                        width: '50%', height: 'fit-content', height: '148px', objectFit: 'cover'
                                    }} />
                                </div>
                            ) : (<>
                                <div htmlFor='image' style={{ position: 'absolute', cursor: 'pointer', height: '150px', width: '100%', border: '1px solid #3b3b3b', borderRadius: '10px', display: 'grid', placeItems: "center" }}>
                                    <PhotoIcon style={{ width: "75px" }} />
                                    <label >Browse</label>
                                </div>
                            </>)}

                            <input type="file" accept='image/*' id="image" placeholder='' onChange={handleFileChange} style={{ opacity: '0', height: '150px', cursor: 'pointer' }} />

                            {errors.badgeImage && (
                                <p className='error-Msg'>{errors.badgeImage}</p>
                            )}
                        </div>
                    </div>
                    <div>
                        <div>
                            <label htmlFor='email'>Core Value Name<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" id="email" placeholder='Enter Core Value Name' onChange={e => setBadgeName(e.target.value)} onInput={e => setBadgeName(e.target.value)} />
                            {errors.badgeName && (
                                <p className='error-Msg'>{errors.badgeName}</p>
                            )}
                        </div>
                    </div>
                </div>

                <div>
                    <Link to="/admin/core-values-awards" className='issue-btn' style={{ marginRight: '20px' }}>Cancel</Link>
                    <input type='submit' value="Save" className='issue-btn' style={{ marginTop: "20px" }} />
                </div>

            </form>


        </div>
    )
}

export default AddValues